module.exports = __webpack_public_path__ + "static/media/animar_thumb_even.6811e21b.jpg";